import {RecordForm} from '../forms/RecordForm';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {moduleConfig} from "../config";
import {Product} from "../types.ts";
import {useProduct} from "../hooks/useProduct.ts";

export const AddPage = () => {
    const { createRecord } = useProduct();

    return (
        <FormPageLayout
            title={`Add ${moduleConfig.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={{} as Product} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};